import React from 'react'

import { Cluster } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { VisuallyHidden } from '@app/lib/display/VisuallyHidden/VisuallyHidden'
import { ChoiceField } from '@app/lib/fields/ChoiceField/ChoiceField'
import { Radio } from '@app/lib/inputs/Radio/Radio'

export enum ClaimCourtCaseOption {
  SelfAssign = 'SelfAssign',
  Unclaimed = 'Unclaimed'
}

export const ClaimCourtCaseChoiceField = () => {
  const { formatMessage } = useIntl()

  return (
    <ChoiceField<ClaimCourtCaseOption>
      name={'claimCourtCase'}
      label={(labelProps) => (
        <VisuallyHidden>
          <label {...labelProps}>claim-court-case</label>
        </VisuallyHidden>
      )}
      defaultValue={ClaimCourtCaseOption.SelfAssign}
      render={({ register }) => (
        <Cluster role='radiogroup'>
          <Radio {...register({ value: ClaimCourtCaseOption.SelfAssign })}>
            {formatMessage({
              id: `CourtCaseDialog.Popup.Radio.SelfAssign`
            })}
          </Radio>
          <Radio {...register({ value: ClaimCourtCaseOption.Unclaimed })}>
            {formatMessage({
              id: `CourtCaseDialog.Popup.Radio.Unclaimed`
            })}
          </Radio>
        </Cluster>
      )}
    />
  )
}
